/* ExportedVideos.js */

import React, { useEffect, useCallback, useState } from 'react';
import { Row, Col, Container, Button, Card, CardBody, CardTitle, Alert } from 'reactstrap';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import PSO from '../../services/PSO';
import { Link } from 'react-router-dom';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import ModalShare from '../../components/modals/ModalShare';
import { IoPlay, IoTrash } from "react-icons/io5";
import { useHistory } from 'react-router-dom';
import { getRemixCover } from '../../helpers/GetRemixCover';
import { toast } from 'react-toastify';
import Button1 from '../../components/buttons/Button1';
import ModalRemoveExportedVideo from '../../components/modals/ModalRemoveExportedVideo';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

const MOVIE_MP4_BASE_URL = process.env.REACT_APP_MOVIE_MP4;
const maxElementsPerRequest = 24;

export default function ExportedVideos() {
  const { authenticated, toggleLoading } = useAuth();
  const history = useHistory();

  const [modalShareOpen, setModalShareOpen] = useState(false);
  const [selectedRemix, setSelectedRemix] = useState();
  const [remixes, setRemixes] = useState();
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getMoreExportedVideos = useCallback(async (lastId) => {
    setIsLoading(true);
    const { un, al } = authenticated;
    try {
      const response = await PSO.getExportedListByUser({ un, al, rnmax: maxElementsPerRequest, lastId });
      if (response && response.its) {
        setRemixes([...remixes, ...response.its]);
        const isToShowLoadMore = (response.its.length === maxElementsPerRequest);
        setShowLoadMore(isToShowLoadMore);
      }
    } catch (err) {
      console.error(err);
      toast.error(Strings('error_while_getting_exported_videos'));
    }
    setIsLoading(false);
  }, [authenticated, setRemixes, setIsLoading, remixes]);

  const getExportedVideos = useCallback(async () => {
    setIsLoading(true);
    const { un, al } = authenticated;
    try {
      const response = await PSO.getExportedListByUser({ un, al, rnmax: maxElementsPerRequest });
      if (response && response.its) {
        setRemixes(response.its);
        const isToShowLoadMore = (response.its.length === maxElementsPerRequest);
        setShowLoadMore(isToShowLoadMore);
      }
    } catch (err) {
      console.error(err);
      toast.error(Strings('error_while_getting_exported_videos'));
    }
    setIsLoading(false);
  }, [authenticated, setRemixes, setIsLoading]);
  useEffect(() => { getExportedVideos(); }, [getExportedVideos]);

  const [modalRemove, setModalRemove] = useState(false);
  const [removeMovid, setRemoveMovid] = useState();
  const removeExportedVideo = useCallback(async () => {
    toggleLoading(true);
    const { un, al } = authenticated;
    const mid = removeMovid;
    try {
      const pars = { un, al, mid };
      const response = await PSO.removeExported(pars);
      if (response && response.result === 'success') {
        setRemoveMovid();
        getExportedVideos();
      } else {
        toast.error(Strings('error_while_removing_exported_video'));
      }
    } catch (err) {
      console.error(err);
      toast.error(Strings('error_while_removing_exported_video'));
    }
    toggleLoading(false);
  }, [authenticated, removeMovid, setRemoveMovid, getExportedVideos, toggleLoading]);

  return (
    <>
      <AppBar2 />

      <div className='dashboard-page'>
        <Container fluid className='pb-4'>
          <Row className='pt-4 bg-white-dashboard pb-3'>
            <Col md={8} className='d-flex align-items-center'>
              <div>
                <h1 className='h3'>{Strings('my_exported_videos')}</h1>
                <p className='mb-0'>
                  <span className='mr-10px'>{Strings('pb_social_links_text_3')}</span>
                </p>
              </div>
            </Col>
            <Col md={4} className='d-flex justify-content-end align-items-center'>
              <Link to='create' className='btn btn-primary btn-lg pb-btn-1'>
                {Strings('create_music_video')}
              </Link>
            </Col>
          </Row>

          <Row className='mt-5'>
            {remixes && remixes.length === 0 && (
              <Col sm={12} md={6}>
                <Alert color='secondary'>
                  {Strings('no_exported_videos')}
                </Alert>
              </Col>
            )}
            {remixes && remixes.length > 0 && remixes.map((item) => (
              <Col xs={12} sm={12} md={4} lg={3} key={`${item.rid}-${item.movid}`} className='mb-3'>
                <Card className='shadow'>
                  <img
                    src={getRemixCover(item)}
                    title={item.ti}
                    alt={item.bo}
                    className='cursor-pointer'
                    onClick={() => history.push(`edit/${item.rid}`)}
                  />
                  <CardBody>
                    <CardTitle tag="h5">
                      {item.ti}
                    </CardTitle>
                    <div className='d-flex justify-content-between'>
                      <div>
                        <a
                          href={`${MOVIE_MP4_BASE_URL.replace('{id}', item.movid)}`}
                          className='btn btn-primary pb-btn-1 mr-2-important'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {Strings('download')}
                        </a>
                        <Link to={`edit/${item.rid}`} className='btn btn-secondary mr-2-important'>
                          {Strings('edit')}
                        </Link>
                        <button
                          className='btn btn-secondary mr-2-important'
                          onClick={() => {
                            setRemoveMovid(item.movid);
                            setModalRemove(true);
                          }}
                        >
                          <IoTrash />
                        </button>
                      </div>
                      <div>
                        <Button onClick={() => {
                          setSelectedRemix(item);
                          setModalShareOpen(true);
                        }}>
                          <IoPlay size='1.2em' />
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}

            {showLoadMore && (
              <Col sm={12} className='d-flex justify-content-center mt-5'>
                <Button1
                  className='pb-btn-1'
                  size='lg'
                  onClick={() => {
                    const lastRemix = remixes[remixes.length - 1];
                    const lastId = lastRemix.movid;
                    if (lastRemix && lastRemix.rid) { getMoreExportedVideos(lastId); }
                  }}
                  loading={isLoading}
                  disabled={isLoading}
                >
                  {Strings('load_more')}
                </Button1>
              </Col>
            )}
          </Row>

          <ModalShare open={modalShareOpen} setOpen={setModalShareOpen} remix={selectedRemix} />

          <ModalRemoveExportedVideo open={modalRemove} setOpen={setModalRemove} confirm={removeExportedVideo} />

        </Container>
      </div>

      <Footer1 />
    </>
  );
}
